import { render } from "./Redirect.vue?vue&type=template&id=a023401c&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"

import "./Redirect.vue?vue&type=style&index=0&id=a023401c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a023401c"]])

export default __exports__